import SummaryContent from '@/components/booking-summary/SummaryContent';
import { ChangeBookingSummaryRows } from '@/components/manage/change-trips/ChangeBookingSummaryRows';
import PriceDisplay from '@/components/PriceDisplay';
import type { BookingSummaryData } from '@/hooks/useBookingSummaryData';
import { useChangeBookingSelection } from '@/hooks/useChangeBookingSelection';
import { useChangeTotal } from '@/hooks/useChangeTotal';
import { TransText } from '@/i18n/trans/text';
import {
  Card,
  Divider,
  Icons,
  Typography,
} from '@packages/webshop-design-system';
import type { FC } from 'react';

const RegularBookingSummary: FC<BookingSummaryData> = ({
  displayPrice,
  ...props
}) => {
  const { hasSelection } = useChangeBookingSelection();
  const changeTotal = useChangeTotal();
  return (
    <Card className="w-[320px] p-0">
      <SummaryContent {...props} />
      {hasSelection && <ChangeBookingSummaryRows />}
      <Divider variant="medium" className="border-primary" />
      <div className="flex flex-row justify-between p-4">
        <div className="flex gap-2">
          <Icons.shoppingCart className="text-primary" />
          <Typography variant="body1-bold">
            <TransText i18nKey={hasSelection ? 'changeTotal' : 'totalPrice'} />
          </Typography>
        </div>
        <Typography variant="subtitle" className="text-primary">
          {hasSelection ? (
            changeTotal
          ) : (
            <PriceDisplay amount={displayPrice?.amount} />
          )}
        </Typography>
      </div>
    </Card>
  );
};

export default RegularBookingSummary;
